import React, { useContext, useMemo } from "react";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Title,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Bar } from "react-chartjs-2";
import { FilterContext } from "../../../context/Filter";

// ✅ Register Chart.js components + plugin
ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Title,
  ChartDataLabels
);

const SalesComplaintTat = ({ data = [] }) => {
  const { selectedYear, setSelectedYear } = useContext(FilterContext);

  // ✅ Safely memoize data
  const filteredData = useMemo(() => {
    if (!Array.isArray(data)) return [];
    return data;
  }, [data]);

  const labels = filteredData.map((item) => item.month || item.year);

  const chartData = {
    labels,
    datasets: [
      {
        label: "Closed Within TAT",
        data: filteredData.map((item) => item.confirmedPercentage || 0),
        backgroundColor: "#4CAF50",
        borderRadius: 6,
        barPercentage: 0.4, // ✅ control individual bar width
        categoryPercentage: 0.6, // ✅ spacing between groups
      },
      {
        label: "Closed Outside TAT",
        data: filteredData.map((item) => item.nonConfirmedPercentage || 0),
        backgroundColor: "#F44336",
        borderRadius: 6,
        barPercentage: 0.4,
        categoryPercentage: 0.6,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: "top" },
      title: {
        display: true,
        text: "Complaints Closed Within & Outside TAT (%)",
      },
      datalabels: {
        display: true,
        color: "white",
        font: { weight: "bold", size: 12 },
        formatter: (val) => `${val}%`,
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.dataset.label}: ${context.parsed.y}%`,
        },
      },
    },
    scales: {
      x: {
        stacked: true,
        grid: { display: false },
        title: {
          display: true,
          text: "Year / Month",
          font: { weight: "bold", size: 13 },
        },
        ticks: {
          font: { weight: "bold", size: 12 },
          maxRotation: 0, // keep horizontal
          minRotation: 0,
          autoSkip: false, // show all labels
          padding: 10,
        },
      },
      y: {
        display: false,
        stacked: true,
        beginAtZero: true,
        max: 100,
      },
    },
  };

  return (
    <div className="w-full bg-white p-4 rounded-xl shadow overflow-x-auto flex flex-col items-center">
      {/* Chart Container */}
      <div
        style={{
          width: Math.max(filteredData.length * 120, 600), // slightly reduced spacing
          height: 270,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Bar data={chartData} options={options} />
      </div>
    </div>
  );
};

export default SalesComplaintTat;
